// extracted by mini-css-extract-plugin
export default {"root":"GameList_root__YugwT"};